import {
    CountriesEnum,
    getRecommendedLanguages,
} from '@routellers/types/dist/shared/enum/countries.enum';
import { Languages } from '@routellers/types/dist/shared/enum/languages.enum';

/** Locale tab languages for city content, keyed by country. */
export const contentLanguagesForCountry = (
    country?: CountriesEnum | string | null,
): Languages[] => getRecommendedLanguages((country as CountriesEnum) || null);
